/*
 * @Author: your name
 * @Date: 2021-08-19 19:34:42
 * @LastEditTime: 2021-12-08 11:10:36
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \鲁南\src\modules\workshopEmergencyHandle\api.js
 */
export default {
  addEmergencyHandleProcess: '/bas/emergency/addEmergencyHandleProcess.json',
  queryEmergencyHandleProcessList: '/bas/emergency/queryEmergencyHandleProcessList.json',
  queryEmergencyHandleProcessDetail: '/bas/emergency/queryEmergencyHandleProcessDetail.json',
  updateEmergencyHandleProcess: '/bas/emergency/updateEmergencyHandleProcess.json',
  deleteEmergencyHandleProcess: '/bas/emergency/deleteEmergencyHandleProcess.json',
  // 应急组
  queryWorkShopGroup: '/cms/workgroup/queryWorkShopGroup.json',
  addWorkShopGroup: '/cms/workgroup/addWorkShopGroup.json',
  deleteWorkShopGroup: '/cms/workgroup/deleteWorkShopGroup.json',
  updateWorkShopGroup: '/cms/workgroup/updateWorkShopGroup.json',
  queryWorkShopGroupInfo: 'cms/workgroup/queryWorkShopGroupInfo.json',
  queryOutWorkShopGroupInfo: '/cms/workgroup/queryOutWorkShopGroupInfo.json',
  queryWorkshopPersonnel: '/cms/workgroup/queryPersonnel.json',
  queryInWorkShopGroupInfo: '/cms/workgroup/queryInWorkShopGroupInfo.json',
  addWorkShopGroupInfo: '/cms/workgroup/addWorkShopGroupInfo.json',
  deleteWorkShopGroupInfo: '/cms/workgroup/deleteWorkShopGroupInfo.json',
  queryDepartmentTree: '/vas/department/queryDepartmentTree.json',
  // 综合应急组
  queryIntegratedGroup: '/cms/workgroup/queryIntegratedGroup.json',
  addIntegratedGroup: '/cms/workgroup/addIntegratedGroup.json',
  updateIntegratedGroup: '/cms/workgroup/updateIntegratedGroup.json',
  deleteIntegratedGroup: '/cms/workgroup/deleteIntegratedGroup.json',
  queryOutIntegratedGroupInfo: '/cms/workgroup/queryOutIntegratedGroupInfo.json',
  queryInIntegratedGroupInfo: '/cms/workgroup/queryInIntegratedGroupInfo.json',
  addIntegratedGroupInfo: '/cms/workgroup/addIntegratedGroupInfo.json',
  queryIntegratedGroupInfo: '/cms/workgroup/queryIntegratedGroupInfo.json',
  deleteIntegratedGroupInfo: '/cms/workgroup/deleteIntegratedGroupInfo.json',
  queryPersonnelOrAccount: '/cms/workgroup/queryPersonnelOrAccount.json',
  queryBuildingTree: '/cms/building/queryBuildingTree.json', //查询楼栋/楼层树
}